import { type PropsWithChildren, type Ref, forwardRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  contentRef: Ref<SVGGElement>
  height: number
  width: number
  ref: Ref<SVGSVGElement>
}

const Frame = forwardRef<SVGSVGElement, PropsWithChildren<Props>>(function Frame(
  { children, contentRef, height, width },
  ref
) {
  return (
    <Box className={'Frame_frame'}>
      <div id="orgchart-div" style={{ width: width, height: height }}>
        <svg ref={ref} width={width} height={height}>
          <g ref={contentRef}>{children}</g>
        </svg>
      </div>
    </Box>
  )
})

export default Frame
